import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router'
import Select from "react-select"

import { normalize, usePet } from '../../modules'

import Modal from "../resusable/modal"

const PayModal = ({ toggle, visible, order, onPerform }) => {
    const [selected, setSelected] = useState([])

    const close = () => {
        toggle()
        onPerform()
    }

    const changeAmount = (i, val) => {
        let temp = [...selected]
        temp[i].amount = Number(val)
        setSelected(temp)
    }

    const changeRef = (i, val) => {
        let temp = [...selected]
        temp[i].ref = val
        setSelected(temp)
    }

    let methods = ['Cash', 'M-Pesa', 'PDQ', 'Cheque']

    const onComplete = ({ data }, notif, ops, closeNotif) => {
        if (data.change) {
            notif(`Please give the customer change of Ksh. ${Math.abs(data.change.amount)}`, ops('success', () => (
                <button
                    className="close-notif"
                    onClick={ () => closeNotif() }>
                    Close
                </button>
            ), true))
        } else {
            notif('Payment has been recorded', ops('success'))
        }

        close()        
    }

    const [{ loading }, execute] = usePet('recordPayments', {
        order: order?._id,
        payments: selected.map(({ ref, value, amount }) => ({
            ref, 
            method: value, 
            amount
        }))
    }, { notify: true, callback: onComplete, manual: true, load: { msg: 'Recording payment...' } })

    return (
        <Modal
            h="h-auto"
            w="w-2/3 md:w-1/2 xl:w-1/3"
            title="Record Payment"
            toggle={toggle}
            visible={visible}>
            <div className="flex mb-2 items-center flex-col">
                <Select
                    value={selected}
                    isMulti
                    styles={{ input: styles => ({ ...styles, minWidth: '10em' }) }}
                    onChange={setSelected}
                    options={methods.map(method => ({ label: method, value: method, amount: 0 }))}
                    placeholder="Select payment methods" />
            </div>
            <p className="font-semibold">Payments</p>
            {
                selected?.length > 0 ?
                    <table className="table-auto w-full mt-3">
                        {/* Table header */}
                        <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                            <tr>
                                <th className="p-2">
                                    <div className="font-semibold text-center">No</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-left">Method</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-center">Amount</div>
                                </th>
                                <th className="p-2">
                                    <div className="font-semibold text-center">Ref</div>
                                </th>
                            </tr>
                        </thead>
                        <tbody className="text-sm font-medium divide-y divide-gray-100">
                            {
                                selected?.map((option, key) =>
                                    <tr>
                                        <td className="p-2">
                                            <div className="text-center">{key + 1}.</div>
                                        </td>
                                        <td className="p-2">
                                            <div className="">{option.label}</div>
                                        </td>
                                        <td className="p-2 text-center">
                                            <input onChange={ e => changeAmount(key, e.target.value) } placeholder="Amount" className="form-input w-24 text-center text-gray-500 hover:text-gray-600 font-medium focus:border-gray-300 active" type="text" style={{ outline: 'none' }} />
                                        </td>
                                        <td className="p-2 text-center">
                                            <input onChange={ e => changeRef(key, e.target.value) } placeholder="Codes / Description" className="form-input w-36 text-center text-gray-500 hover:text-gray-600 font-medium focus:border-gray-300 active" type="text" style={{ outline: 'none' }} />
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                    </table>
                    :
                    <div className="text-center my-5">
                        <h2>Please select a payment method above</h2>
                    </div>
            }
            <div className="flex flex-col items-end pr-3 py-3">
                <p className="font-semibold text-lg underline mb-2">Overview</p>
                <p className="mb-1">Total: Ksh. { normalize(order?.items?.reduce((total, itm) => total + (itm?.unitPrice * itm?.quantity), 0) - (order?.discount ?? 0)) }</p>
                <p className="mb-1">Paid: Ksh. { normalize(order?.payments?.reduce((total, payment) => total + payment?.amount, 0)) + normalize(selected.reduce((total, method) => total + method.amount, 0)) }</p>
                <p className="mb-1">Balance: Ksh. { normalize((order?.items?.reduce((total, itm) => total + (itm?.unitPrice * itm?.quantity), 0) - (order?.discount ?? 0)) - (normalize(order?.payments?.reduce((total, payment) => total + payment?.amount, 0)) + selected.reduce((total, method) => total + method.amount, 0))) }</p>
            </div>
            <div className="text-right">
                <button onClick={ close } className="px-4 py-3 rounded-md outline-none focus:ring-4 shadow-lg mr-4">Close</button>
                <button disabled={ loading } onClick={ execute } className="text-white hisani-btn-orange mt-2 font-medium rounded-lg text-sm px-5 py-2.5 text-center">Record Payment</button>
            </div>
        </Modal>
    )
}

export default PayModal